import React from 'react';

import { Achievement } from './achievements/types';
import './achievement.css';

interface AchievementMenuProps {
  achievements: Achievement[];
  onClose: () => void;
}

export const AchievementMenu: React.FC<AchievementMenuProps> = ({
  achievements,
  onClose,
}) => {
  const unlockedCount = achievements.filter(
    achievement => achievement.unlocked
  ).length;
  const totalCount = achievements.length;
  const formatProgressValue = (value: number): string =>
    value.toLocaleString(undefined, { maximumFractionDigits: 0 });

  return (
    <div
      className='achievement-menu-overlay'
      role='dialog'
      aria-modal='true'
      aria-label='Achievements'
    >
      <div className='achievement-menu'>
        <header className='achievement-menu__header'>
          <div className='achievement-menu__title-group'>
            <h3>🏆 Achievements</h3>
            <p className='achievement-menu__progress'>
              {unlockedCount} / {totalCount} unlocked
            </p>
          </div>
          <button
            className='close-button achievement-menu__close'
            onClick={onClose}
            title='Close Achievements'
            type='button'
          >
            ✕
          </button>
        </header>

        <div className='achievement-menu__body'>
          {achievements.length === 0 ? (
            <div className='achievement-menu__empty'>
              <p>No achievements available yet.</p>
            </div>
          ) : (
            <div className='achievement-menu__list'>
              {achievements.map(achievement => {
                const progress = achievement.progress;

                return (
                  <div
                    key={achievement.id}
                    className={`achievement-menu__card ${
                      achievement.unlocked
                        ? 'achievement-menu__card--unlocked'
                        : 'achievement-menu__card--locked'
                    }`}
                  >
                    <div className='achievement-menu__icon'>
                      {achievement.icon}
                      {!achievement.unlocked && (
                        <span
                          className='achievement-menu__lock'
                          aria-hidden='true'
                        >
                          🔒
                        </span>
                      )}
                    </div>
                    <div className='achievement-menu__info'>
                      <div className='achievement-menu__name'>
                        {achievement.name}
                      </div>
                      <div className='achievement-menu__description'>
                        {achievement.description}
                      </div>
                      {progress && (
                        <div className='achievement-menu__progress-detail'>
                          {formatProgressValue(progress.current)} /{' '}
                          {formatProgressValue(progress.target)}
                        </div>
                      )}
                      {achievement.unlocked && achievement.unlockedAt && (
                        <div className='achievement-menu__timestamp'>
                          Unlocked{' '}
                          {new Date(
                            achievement.unlockedAt
                          ).toLocaleDateString()}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AchievementMenu;
